module.exports = __webpack_public_path__ + "img/logo-barriera-2.60ad0933.png";